import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router";

import { captureException } from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";

import { makeQueryClient } from "@virtual-brain-lib/frontend-api";

import router from "./router";

const queryClient = makeQueryClient();

export default function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ErrorBoundary
				fallback={<div>Something went wrong</div>}
				onError={(error) => {
					captureException(error);
				}}
			>
				<RouterProvider router={router} />
				<Toaster />
			</ErrorBoundary>
		</QueryClientProvider>
	);
}
